/**
 * Determines the countdown date timestamp for an event.
 * Returns undefined if countdowns are hidden, the event has no finalized date, or the date is in the past.
 *
 * @param hideEventCountdown - Whether event countdowns are hidden
 * @param finalizedDateMs - The finalized event date in milliseconds, or null/undefined if not set
 * @returns The countdown date timestamp in milliseconds, or undefined if countdown should not be shown
 */
export const getCountDownDate = (hideEventCountdown: boolean | undefined, finalizedDateMs: number | undefined | null): number | undefined => {
  if (hideEventCountdown || finalizedDateMs == null) {
    return undefined;
  }
  return finalizedDateMs > Date.now() ? finalizedDateMs : undefined;
};
